
import { defineComponent, ref, computed, watch, onMounted } from 'vue'
import markdown from '@/utils/markdown'
import { useRenderedEventDispatcher } from '@/plugins/renderedEventDispatcher'

import '@/assets/scss/pages/home.scss'
import { useStore } from '@/store'

interface Section {
  name: 'notice' | 'about';
  title: string;
  content: string;
}

export default defineComponent({
  name: 'Home',
  setup () {
    const { languageType, languagePack } = useStore()
    const despatchRenderedEvent = useRenderedEventDispatcher()
    const noticeHtml = ref('')
    const aboutHtml = ref('')
    const sections = computed<Section[]>(() => [
      {
        name: 'notice',
        title: languagePack.value.home.notice.title,
        content: noticeHtml.value
      },
      {
        name: 'about',
        title: languagePack.value.home.about.title,
        content: aboutHtml.value
      }
    ])

    const parseMarkdownContent = async () => {
      noticeHtml.value = await markdown(languagePack.value.home.notice.content)
      aboutHtml.value = await markdown(languagePack.value.home.about.content)
    }

    watch(() => languageType.value, parseMarkdownContent)

    onMounted(async () => {
      await parseMarkdownContent()
      despatchRenderedEvent()
    })

    return {
      languagePack,
      sections
    }
  }
})
